const Palette = () => {

    const contrastText = '#fff';

    const paletteColor = {
        menuMain: {
            main: '#FFFFFF',
            contrastText
        },
        simCard: {
            main: '#FFFFFF',
            contrastText: '#111111'
        },
        getEsims: {
            main: 'transparent',
            contrastText
        },
        profileMenuContainer: {
            main: 'transparent',
            contrastText
        }
    };

    return {
        ...paletteColor,
    }
}
export default Palette;
